import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { PreparationPage } from "@/features/fermentation-journal/components/setup";

export const Route = createFileRoute(
  "/fermentations/$group_id/setup/preparation",
)({
  component: SetupIndex,
});

function SetupIndex() {
  const { group_id } = Route.useParams();
  return (
    <div className="max-w-4xl">
      <PreparationPage groupId={group_id as unknown as FermentationGroupId} />
    </div>
  );
}
